import { Injectable } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CMSFormDefinition, CMSFormResponse } from '../../models/form';
import { JSONForm } from '../../models/json-form';
import { BaseService } from '../base.service';

@Injectable({
  providedIn: 'root'
})
export class FormsService extends BaseService {
  private formsUrl = this.apiUrl + '/forms';

  ARGUMENT_NAMES = /([^\s,]+)/g;

  getForms(): Observable<CMSFormResponse> {
    const url = `${this.formsUrl}`;
    return this.http.get<CMSFormResponse>(url);
  }

  /** GET Forms by id. Will 404 if id not found */
  getForm(id: number): Observable<CMSFormResponse> {
    if (+id === 0) {
      return observableOf(this.initializeForms());
    }

    const url = `${this.formsUrl}/${id}`;
    return this.http.get<CMSFormResponse>(url).pipe(
      tap(_ => this.log(`fetched form id=${id}`)),
      tap(res => {
        if (typeof (res.form.definitions) === 'string') {
          res.form.definitions = <CMSFormDefinition[]>JSON.parse(res.form.definitions);
        }
      }),
      // tap(res => res.form.definitions = res.form.definitions),
      tap(res => this.transformValidatorStringToFunction(res)),
      catchError(this.handleError<CMSFormResponse>(`getForm id=${id}`))
    );
  }

  /**
   *  Return an initialized object
   */
  initializeForms(): CMSFormResponse {
    return new CMSFormResponse();
  }

  transformValidatorStringToFunction(res: CMSFormResponse) {
    const definitions = <CMSFormDefinition[]>res.form.definitions;
    definitions.forEach(definition => {
      // const definition = <FieldConfig[]>res.form.definitions.definition;
      definition.definition.forEach(item => {
        const validation = <string[]>item.validation;

        if (validation) {
          item.validation = <ValidatorFn[]>validation.map((fnc: string) => {
            const params = this.getFunctionStringParams(fnc);

            if (fnc.indexOf('(') > -1) { fnc = fnc.slice(0, (fnc.indexOf('('))); }

            if (params.length) {
              return Validators[fnc](params[0]);
            }

            return Validators[fnc];
          });
        }
      });
    });
  }

  getFunctionStringParams(fnStr: string) {
    // let result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(this.ARGUMENT_NAMES);
    let result = [];
    if (fnStr.indexOf('(') > -1) { result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).split(','); }

    if (result === null) { result = []; }

    return result;
  }
}
